import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/jobs/constants';
import type { components } from '@/types/apiSchema';

import { jobsQueryKeys } from './queryKeys';

type JobNoteResponse = components['schemas']['JobNoteResponse'];

export const useJobNotesQuery = (
  jobId: string,
  options?: Omit<
    UseQueryOptions<JobNoteResponse[] | undefined, Error>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: jobsQueryKeys.notes(jobId),
    queryFn: async () => {
      const { data } = await fetchClient.GET(endpoints.jobNotes, {
        params: { path: { id: jobId } },
      });

      return data;
    },
    ...options,
  });
};
